import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, RouterOutlet } from '@angular/router';
import { Router, NavigationStart, NavigationEnd } from '@angular/router';

import { environment } from '@environment';

import { PlatformService } from '@core/services/util/platform.service';
import { SessionStorageService } from '@core/services/util/session-storage.service';
import { GtmService } from '@core/services/analytics/gtm.service';
import { DeviceService } from './core/services/util/device.service';
import { ServiceWorkerService } from './core/services/service-worker.service';
import { ThirdPartyScriptService } from './core/services/third-party-script/third-party-script.service';

import { FooterComponent } from './core/components/footer/footer.component';
import { ChatBubbleComponent } from './core/components/chat-bubble/chat-bubble.component';
import { HeaderComponent } from './core/components/header/header.component';
import { FirebaseService } from './core/services/pushNotification/firebase.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: true,
    imports: [HeaderComponent, ChatBubbleComponent, RouterOutlet, FooterComponent]
})
export class AppComponent implements OnInit {

	// Used to Hide Header incase of Native App
    isNativeApp = false;
    isServer: boolean;
    startTime: number;
    current_page: string;
    previous_page: string;
    isMobile: boolean;
    brandId = environment.brand.id;
    showHeader: boolean;

    constructor(
        private platformService: PlatformService,
        private activeRoute: ActivatedRoute,
        private sessionStorage: SessionStorageService,
        private deviceService: DeviceService,
        private serviceWorkerService: ServiceWorkerService,
        private thirdPartyScriptService: ThirdPartyScriptService,
        private gtmService: GtmService,
        private router: Router,
		private firebaseService: FirebaseService
    ) {
        this.isMobile = this.deviceService.isMobile();
    }

    ngOnInit() {
        if (this.platformService.isBrowser()) {
            this.activeRoute.queryParams.subscribe((qParams: any) => {
                this._storeQueryParams(qParams);
            });

            window.onload = () => {
                try {
                    setTimeout(() => {
						this.firebaseService.initFirebase();
                        this.thirdPartyScriptService.loadScriptsOnClient();
                        // log app version and CDN url to track whether stale bundle are being served or not
                        this.gtmService.logWebAnalyticsEvent(
                            'page_load_details',
                            `App Version: ${environment.VERSION} CDN URL: ${environment.DEPLOY_URL}`
                        );
                        this.serviceWorkerService.sendServiceWorkerKPIData();
                    }, 500);
                } catch (e) {
                    console.log(e);
                }
            };

        }

        this.isNativeApp = this.platformService.isNativeAppWebView();
        this.isServer = this.platformService.isServer();

        // Reload page count

        if (this.platformService.isBrowser()) {
            this.current_page = this.router.url;
            this.router.events.subscribe(event => {
                if (event instanceof NavigationStart) {
                    this.previous_page = this.current_page; // Store current page as previous page
                    this.startTime = performance.now(); // Record the start time
                }
                if (event instanceof NavigationEnd) {
                    if (isNaN(this.startTime) === false) {
                        const endTime = performance.now(); // Record the end time
                        const duration = endTime - this.startTime;
                        this.current_page = event.urlAfterRedirects; // Store current page as current page

                        let effectiveType = 'NOT_SUPPORTED';

                        if (navigator && (<any>navigator).connection) {
                            effectiveType = (<any>navigator).connection.effectiveType; // Record network type
                        }

                        this.gtmService.logEvent('web_analytics', {
                            event_action: 'Page Transition KPI',
                            event_label: 'Transition Time',
                            value1: this.previous_page,
                            value2: this.current_page,
                            value3: duration.toFixed(2),
                            value4: effectiveType
                        });
                    }
                }
            });
        }

        // don't show header for (EatClub mobile at SSR) and (nativeApps)
        this.showHeader = !this.isNativeApp && (!this.isServer || (this.brandId === 1 || this.brandId === 13 || !this.isMobile));
    }

    private _storeQueryParams(qParams: any) {
        try {
            for (const params of Object.keys(qParams)) {
                this.sessionStorage.set(params, qParams[params]);
            }
        } catch (e) {
            console.error(`Error while storing query params: ${e}`);
        }
    }
}
